import { useEffect, ReactNode } from "react";
import { useToast } from "../context/ToastContext";
import api from "../api";

interface ApiInitializerProps {
  children: ReactNode;
}

/**
 * ApiInitializer Component
 * Initializes the API callbacks to show toasts for all API requests.
 * - Success toasts for POST, PUT, DELETE operations
 * - Error toasts for failed requests
 * This ensures centralized notification handling without individual showToast calls in pages.
 */
export default function ApiInitializer({ children }: ApiInitializerProps) {
  const showToast = useToast();

  useEffect(() => {
    // Register the global error callback for the API service
    api.setErrorCallback((message: string, type: "error" | "warning") => {
      showToast(message, type);
    });

    // Register the global success callback for the API service
    api.setSuccessCallback((message: string) => {
      showToast(message, "success");
    });
  }, [showToast]);

  return <>{children}</>;
}
